// extracted by mini-css-extract-plugin
module.exports = {"cta":"style_cta__3ATrS","heading":"style_heading__2igl2","img":"style_img__13Rop","text":"style_text__2L_L_","button":"style_button__1UQgh"};